import React, {useState} from "react";
import {TableCellTextPopper} from "../../../../misc/scroller/TableEditCell";
import {parseMarkup} from "../../shopdrawing/pricing/Pricing";
import {PriceRow} from "./Common";

export function MarkupEditCell2(props: {
    anchor: any;
    row: PriceRow;
    width: number;
    initialValue: string;
    onCancel(): void;
    onDone(value: PriceRow): Promise<any>;
}) {
    const [value, setValue] = useState(props.initialValue);
    const r = props.row;
    if(r.kind !== "quote-price" && r.kind !== "quote-price-rider") return null;
    const objValue = r.value;

    return (
        <TableCellTextPopper
            anchor={props.anchor}
            alignRight
            onEnter={() => {
                props.onDone(Object.assign({}, props.row, {
                    value: Object.assign({}, objValue, parseMarkup(value))
                }))
            }}
            onEsc={props.onCancel}
            onTab={props.onCancel}
            onArrow={() => props.onCancel()}
            onBlur={props.onCancel}
            value={value}
            onChange={setValue}
        />
    )
}
